const ldQuizResult = () => {
    document.addEventListener('DOMContentLoaded', function () {
        const target       = document.querySelector('.wpProQuiz_content');
        const output       = document.getElementById('result_quiz_pre_message');
        const certificate  = document.getElementById('result_quiz_certificate');
        const note_message = document.getElementById('result_quiz_note_message');

        if (!target || !output) return;

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    if (target.classList.contains('ld-quiz-result-failed')) {
                        output.textContent = rcTranslate.quiz_result_failed;
                    }
                    if (target.classList.contains('ld-quiz-result-passed')) {
                        output.textContent = rcTranslate.quiz_result_passed;
                        certificate.style.display = 'flex';
                        note_message.style.display = 'block';
                    }
                }
            });
        });

        observer.observe(target, {
            attributes: true,
            attributeFilter: ['class']
        });
    });

    document.addEventListener('DOMContentLoaded', function () {
        const htmlLang = document.documentElement.lang;

        if (htmlLang === 'uk') {
            const el = document.querySelector('.wpProQuiz_quiz_time');

            if(!el){
                return;
            }

            if (el) {
                el.childNodes.forEach(node => {
                    if (node.nodeType === Node.TEXT_NODE) {
                        node.textContent = node.textContent.replace('Your time:', 'Ваш час:');
                    }
                });
            }
        }
    });
};

export default ldQuizResult;
